import { render, staticRenderFns } from "./view.vue?vue&type=template&id=eba3e59c&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eba3e59c')) {
      api.createRecord('eba3e59c', component.options)
    } else {
      api.reload('eba3e59c', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=eba3e59c&", function () {
      api.rerender('eba3e59c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/locale/view.vue"
export default component.exports